import React from 'react'
import { useAuth } from '@polvo-labs/react-auth'
import { Redirect } from 'react-router-dom'
import routes from '../../config/routes'

interface Props {

}

const Private: React.FC<Props> = ({ children }) => {
  const { authenticated } = useAuth()

  if (!authenticated) {
    return (
      <Redirect
        to={routes.index.path}
      />
    )
  }

  return (
    <>
      {children}
    </>
  )
}

export default Private
